import React, { memo } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";

import makeStyles from '@mui/styles/makeStyles';

import { Chart } from "./chart.jsx";
import { RateChart } from "./rateChart.jsx";

import PitchIcon from "../../../../../assets/images/cargo/load/pitch.svg";
import { COLORS } from "../../../../constants/colors.js";
import localizationKeys from "../../../../i18n/localizationKeys.js";
import { useTranslation } from "react-i18next";
import { convertNumber } from "../commonFunc.js";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
  },
  icon: {
    textAlign: "center",
  },
  gauges: {
    display: "flex",
    height: "120px",
  },
  zeroMarker: {
    color: COLORS.white,
    textAlign: "center",
    fontSize: "8px",
  },
  details: {
    paddingLeft: "15px",
  },
  table: {
    display: "flex",
    justifyContent: "center",
    fontSize: "14px",
    [theme.breakpoints.up("md")]: {
        gap: "8px",
    },
  },
  row: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
        justifyContent: "center",
    },
  },
  label: {
      color: COLORS.white,
      width: "60px",
    },
    value: {
        color: COLORS.greenishBlue,
    },
}));

export const Pitch = memo((props) => {
  const classes = useStyles();
  const { data } = props;
  const { t } = useTranslation();
  const pitch = convertNumber(data[0]?.inputData);
  const rate = convertNumber(data[1]?.inputData);

  return (
    <Grid container className={classes.container} justifyContent="center" alignItems="center">
      <Grid item size={{xs:5, md:4}} className={classes.icon}>
        <img src={PitchIcon} width={74} height={41} />
      </Grid>
      <Grid item size={{xs:7, md:4}}>
        <Grid container className={classes.gauges} justifyContent="center" alignItems="center">
          <Grid item size={{xs:6}}>
            <Chart pitch={pitch} />
          </Grid>
          <Grid item size={{xs:2}} className={classes.zeroMarker}>
            0
          </Grid>
          <Grid item size={{xs:4}}>
            <RateChart rate={rate} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item size={{xs:12, md:4}} className={classes.details}>
        <Grid container className={classes.table}>
            <Grid item size={{xs: 6, md: 12}} className={classes.row}>
                <div className={classes.label}>Pitch</div>
                <div className={classes.value}>{isNaN(pitch) ? `${t(localizationKeys.NoLatestData)}.` : `${pitch.toFixed(2)} deg`}</div>
            </Grid>
            <Grid item size={{xs: 6, md: 12}} className={classes.row}>
                <div className={classes.label}>{t(localizationKeys.YAngularVelocity)}</div>
                <div className={classes.value}>{isNaN(rate) ? `${t(localizationKeys.NoLatestData)}.` : `${rate.toFixed(2)} deg/s`}</div>
            </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});

Pitch.propTypes = {
  data: PropTypes.array,
};
